import React from 'react';

const CompanyDetails = () => {
  return (
    <>
      <div className="row">
        <div className="col-md-6">
          <div className="subtitle bigger">
            Our vision
            <div className="extra">
              We want to disrupt industries with our clients. We aim to become
              the go-to partner for innovative tech companies around the world
              and move our society forward with them. Our job is to provide
              top-notch software engineering and technological strategic
              management. <br />
              <br />
              We provide IT services, customer service, product, methodology,
              and technology expertise on a world-class level with total
              transparency.
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-6">
          <div className="board">
            <h3>Vision</h3>
            <p>
              We aim to be the go-to partner for the best global tech-based
              companies. We will do so by offering the best in class software
              engineering and technological strategic management.
            </p>
          </div>
        </div>
        <div className="col-md-6">
          <div className="board">
            <h3>Mission</h3>
            <p>
              We provide IT services, customer service, product, methodology and
              technology expertise on a world-class level. Keeping our standards
              high allows Ulam Labs to be the most desired technological partner
              in the industry.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default CompanyDetails;
